import { useEffect, useRef } from 'react';
import type { BreadcrumbItem } from './BreadcrumbsContext';
import { useBreadcrumbContext } from './BreadcrumbsContext';

/**
 * BreadcrumbsCrumb component registers a breadcrumb item in the BreadcrumbContext.
 * It updates the breadcrumb item when its props change and removes it when unmounted.
 */
export const BreadcrumbsCrumb = ({ id, label, href }: BreadcrumbItem) => {
    const { setCrumb, removeCrumb } = useBreadcrumbContext();

    const prevLabel = useRef<string>();
    const prevHref = useRef<string>();

    useEffect(() => {
        if (prevLabel.current === label && prevHref.current === href) return;

        prevLabel.current = label;
        prevHref.current = href;
        setCrumb({ id, label, href });
    }, [id, label, href, setCrumb]);

    useEffect(() => {
        return () => removeCrumb(id);
    }, [removeCrumb, id]);

    return null;
};
